import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: props.width ?? props.size ?? "1em",
	height: props.height ?? props.size ?? "1em",
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1600000743",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M15.0162 11.5376H18.5797C19.132 11.5376 19.5797 11.0898 19.5797 10.5376V5.57492C19.5797 5.25498 19.4266 4.95436 19.1678 4.76618L14.6916 1.51077C14.341 1.25575 13.866 1.25575 13.5153 1.51077L9.67188 4.30599",
			stroke: "currentColor",
			strokeOpacity: .4,
			strokeMiterlimit: 10
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M14.6054 7.91894C14.8642 8.10712 15.0172 8.40774 15.0172 8.72767V15.8476C15.0172 16.3999 14.5695 16.8476 14.0172 16.8476H1.41406C0.861778 16.8476 0.414062 16.3999 0.414062 15.8476V8.72768C0.414062 8.40774 0.567147 8.10712 0.825891 7.91894L7.12748 3.33596C7.47813 3.08095 7.95317 3.08095 8.30383 3.33596L14.6054 7.91894Z",
			stroke: "currentColor",
			strokeMiterlimit: 10
		})]
	})
});
export default SvgLocation;
